import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { canUseMarketingSegment } from '../../utils/segment';
// Registra o namespace de i18n do segmento antes de qualquer tela dele montar.
import '../../i18n/marketingSegment';

/** Guarda das rotas /marketing/*: sem acesso ao segmento, volta para o Fashion. */
const MarketingSegmentRoute: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  if (!canUseMarketingSegment(user)) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default MarketingSegmentRoute;
